import { useMutation } from 'react-query';

import { axios } from 'configurations/axios';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';

type AssociateSeismicAttributeParams = {
    volumeToken: string;
    seismicProductToken: string;
};

export const useAssociateSeismicAttribute = () => {
    const { tenantConfig, jwt } = useSessionStore((state) => ({
        tenantConfig: state.tenantConfiguration,
        jwt: state.jwtToken,
    }));

    return useMutation<boolean, unknown, AssociateSeismicAttributeParams>(
        async ({ volumeToken, seismicProductToken }) => {
            const response = await axios.post<IResponseAPI<boolean>>(
                `${tenantConfig?.endpoints.attributes}/Seismic/Attributes`,
                {
                    volumeToken,
                    seismicProductToken,
                    company: '',
                    year: 0,
                    defaultMinValue: 0,
                    defaultMaxValue: 0,
                    productTypeToken: '',
                    seismicLineProductToken: '',
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        }
    );
};
